import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/vercel/path0/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/app/layouts/default.vue").then(m => m.default || m))
}